import { TranslationDict } from "../types";

export const frSettings: TranslationDict = {
  instellingen: "Paramètres",

  gebruikPaketten: "Utiliser des packages",
  infoPakettenAan1: "Coché, nous utiliserons des packages si applicable.",
  infoPakettenAan2: "Décochez, nous utiliserons des modules individuels.",

  gebruikEnkelSa: "Utiliser uniquement les modules REL04SA (pas de REL08)",
  infoSaAan1: "Coché, nous utiliserons uniquement le module relais 'Stand Alone'.",
  infoSaAan2: "Décochez, nous utiliserons également un module REL08.",

  upgradeController: "Mettre à niveau le contrôleur à x adresses",
  infoUpgradeController1: "Un ctd peut utiliser un maximum de 388.",
  infoUpgradeController2: "Définissez ici le nombre d'adresses à partir duquel un contrôleur supplémentaire doit être ajouté.",
  
  standaardUitvoering: "Exécution standard",
  infoStandaardUitvoering: "Définissez ici la finition de vos boutons.",

  taal: "Langue",
  infoTaal: "Définissez ici votre langue préférée.",
};